import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cf0338f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-minted"
}
const _hoisted_2 = {
  key: 0,
  ref: "scrollContainer",
  class: "m-minted-carousel"
}
const _hoisted_3 = { class: "m-minted-carousel-inner" }
const _hoisted_4 = {
  key: 1,
  class: "m-minted-grid"
}

import { RevealedToken } from "@manifoldxyz/collectible-sdk";
import Token from "./Token.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Minted',
  props: {
    numberMinted: {},
    tokens: {},
    asCarousel: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props;




const onClose = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (props.tokens.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.asCarousel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tokens, (token, idx) => {
                  return (_openBlock(), _createBlock(Token, {
                    key: idx,
                    "number-minted": _ctx.numberMinted,
                    token: token
                  }, null, 8, ["number-minted", "token"]))
                }), 128))
              ])
            ], 512))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tokens, (token, idx) => {
                return (_openBlock(), _createBlock(Token, {
                  key: idx,
                  "number-minted": _ctx.numberMinted,
                  token: token
                }, null, 8, ["number-minted", "token"]))
              }), 128))
            ])),
        _createElementVNode("button", { onClick: onClose }, "Return")
      ]))
    : _createCommentVNode("", true)
}
}

})